var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMoreVer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4501 9.23L19.4501 5.77L14.6601 8.54V3H10.6601V8.54L5.87012 5.77L3.87012 9.23L8.66012 12L3.87012 14.77L5.87012 18.23L10.6601 15.46V21H14.6601V15.46L19.4501 18.23L21.4501 14.77L16.6601 12L21.4501 9.23Z",
    fill: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoreVer);
export default __webpack_public_path__ + "static/media/icon-more-ver.2bc7b2c311f9e22e526071fa2e8a2686.svg";
export { ForwardRef as ReactComponent };